import { isAxiosError } from 'axios'

// 404 with the RLCP-specific detail body means the report number doesn't exist.
export function isRlcpNotFoundError(error: unknown): boolean {
  return (
    isAxiosError(error) &&
    error.response?.status === 404 &&
    /^RLCP report '.+' not found\.$/.test(error.response.data?.detail ?? '')
  )
}
